/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Days_Per_Week_ShortInputs */

const en_us2_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chooses the split`)
};

const pt_br2_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe a divisão`)
};

const es_419_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige la división`)
};

const pt_pt2_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe a divisão`)
};

const fr_fr2_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisit la répartition`)
};

const de_de2_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählt den Split`)
};

const it_it2_intake_why_days_per_week_short = /** @type {(inputs: Intake_Why_Days_Per_Week_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sceglie lo split`)
};

/**
* | output |
* | --- |
* | "Chooses the split" |
*
* @param {Intake_Why_Days_Per_Week_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_days_per_week_short = /** @type {((inputs?: Intake_Why_Days_Per_Week_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Days_Per_Week_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_days_per_week_short(inputs)
	if (locale === "es-419") return es_419_intake_why_days_per_week_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_days_per_week_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_days_per_week_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_days_per_week_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_days_per_week_short(inputs)
	return en_us2_intake_why_days_per_week_short(inputs)
});
export { intake_why_days_per_week_short as "intake.why.days_per_week.short" }